var map = {
	"./collideEntities.js": "./libs/noa/src/components/collideEntities.js",
	"./collideTerrain.js": "./libs/noa/src/components/collideTerrain.js",
	"./fadeOnZoom.js": "./libs/noa/src/components/fadeOnZoom.js",
	"./followsEntity.js": "./libs/noa/src/components/followsEntity.js",
	"./mesh.js": "./libs/noa/src/components/mesh.js",
	"./movement.js": "./libs/noa/src/components/movement.js",
	"./physics.js": "./libs/noa/src/components/physics.js",
	"./position.js": "./libs/noa/src/components/position.js",
	"./receivesInputs.js": "./libs/noa/src/components/receivesInputs.js",
	"./shadow.js": "./libs/noa/src/components/shadow.js",
	"./smoothCamera.js": "./libs/noa/src/components/smoothCamera.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./libs/noa/src/components sync \\.js$";